import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/shadcn/tooltip';

import type { DiffStats } from '@/components/monaco/diffViewer/utils/diffStats.diffViewer';

type Props = {
  diffStats: DiffStats;
};

export const DiffStatsDisplay = ({ diffStats }: Props) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <p className="inline-flex cursor-pointer items-center gap-2.5 rounded-sm border border-border bg-accent px-2 py-1.5 pb-1 font-mono font-semibold leading-none">
          <span className="text-diff-addition">
            <span className="mr-0.5">+</span>
            {diffStats.additions}
          </span>
          <span className="text-diff-deletion">
            <span className="mr-0.5">−</span>
            {diffStats.deletions}
          </span>
          <span className="text-diff-modification">
            <span className="mr-0.5">~</span>
            {diffStats.modifications}
          </span>
        </p>
      </TooltipTrigger>
      <TooltipContent>
        <div className="grid grid-cols-[auto_auto_1fr] items-center gap-x-1.5 gap-y-1">
          <span className="pt-0.5 font-bold font-mono text-diff-addition">
            +
          </span>
          <span className="text-diff-addition">{diffStats.additions}</span>
          <span>{diffStats.additions === 1 ? 'line' : 'lines'} added</span>
          <span className="pt-0.5 font-bold font-mono text-diff-deletion">
            −
          </span>
          <span className="text-diff-deletion">{diffStats.deletions}</span>
          <span>{diffStats.deletions === 1 ? 'line' : 'lines'} removed</span>
          <span className="pt-0.5 font-bold font-mono text-diff-modification">
            ~
          </span>
          <span className="text-diff-modification">
            {diffStats.modifications}
          </span>
          <span>
            {diffStats.modifications === 1 ? 'line' : 'lines'} modified
          </span>
        </div>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
